import { render, staticRenderFns } from "./ActivityQuestionSettings.vue?vue&type=template&id=e99e21f8&"
import script from "./ActivityQuestionSettings.vue?vue&type=script&lang=js&"
export * from "./ActivityQuestionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports